<template>
	<Autocomplete
		:display-name="users ? t('entity.user.name') : t('entity.person.name', 2)"
		:icon="users ? icon : 'fa-fw far fa-address-book'"
		:label="
			label === null
				? null
				: label
					? label
					: users
						? t('entity.user.name')
						: t('entity.person.name', 2)
		"
		:endpoint="
			endpoint
				? endpoint
				: withHpId
					? url + '&=person.hp_id'
					: users
						? 'persons?finn=user_id'
						: url
		"
		:multiple="multiple"
		:chips="multiple"
		:name="name"
		:params="{
			...{
				rel,
				of: 'lastname',
				od: 'asc',
			},
			...params,
		}"
		:item-title="
			(item: Api.User | Api.Person) =>
				personBuildFullname(getPerson(item), {
					isTeam: item?.is_team ?? false,
				})
		"
		:item-value="itemValue"
		:preload-all-pages="false"
		data-test="users-autocomplete"
		v-bind="$attrs"
	>
		<template v-if="multiple && chips" #chip="{ item, props }">
			<v-chip
				v-if="item === Object(item)"
				v-bind="props"
				:text="item.title"
				:prepend-icon="
					item.raw?.user_id !== null || item.raw?.user
						? 'fa-fw fal fa-user'
						: 'fa-fw fas fa-user-alt-slash'
				"
				size="small"
			></v-chip>
		</template>
		<template #item="{ item, props }">
			<v-list-item
				v-bind="props"
				:title="
					personBuildFullname(getPerson(item.raw), {
						isTeam: item.raw?.is_team ?? false,
					})
				"
				:subtitle="getPerson(item.raw).user?.email"
				:key="item.raw.id"
			>
				<template v-if="!users" #append>
					<v-icon
						:icon="
							item.raw?.user_id !== null || item.raw?.user
								? 'fa-fw fal fa-user'
								: 'fa-fw fas fa-user-alt-slash'
						"
						:color="
							item.raw?.user_id !== null || item.raw?.user
								? 'grey'
								: 'warning'
						"
						size="small"
					></v-icon>
				</template>
			</v-list-item>
		</template>
	</Autocomplete>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Autocomplete from '../Validation/Autocomplete.vue'
import { personBuildFullname } from '@/filters'
import { useI18n } from 'vue-i18n'

defineProps({
	endpoint: {
		default: undefined,
		type: String,
	},
	icon: {
		default: 'fa-fw fas fa-users-cog',
		type: String,
	},
	label: {
		default: 'entity.user.name',
		type: String,
	},
	multiple: {
		type: Boolean,
		default: true,
	},
	name: {
		default: 'users',
		type: String,
	},
	users: {
		type: Boolean,
		default: true,
	},
	withHpId: {
		type: Boolean,
		default: false,
	},
	itemValue: {
		type: String,
		default: 'id',
	},
	params: {
		type: Object,
		default: () => ({}),
	},
	chips: {
		default: false,
		type: Boolean,
	},
})
const { t } = useI18n()
const url = ref('persons')
const rel = ref('["user"]')

function getPerson(item) {
	return item.person ? item.person : item
}
</script>

<style scoped></style>
